"use client";

import React from "react";
import SubPageLayout from "@/components/common/SubPageLayout";
import DiagramSection from "@/components/diagrams/DiagramSection";
import DiagramCard from "@/components/diagrams/DiagramCard";
import WedgeWireProfileDiagram from "@/components/diagrams/WedgeWireProfileDiagram";
import { useLanguage } from "@/hooks/useLanguage";
import { pick } from "@/lib/i18n";
import { SIEVE_BEND_CONTENT } from "./content";
export default function SieveBendScreensPage() {
  const {
    lang
  } = useLanguage();
  const content = pick(lang, SIEVE_BEND_CONTENT);
  const diagramTitle = pick(lang, {
    en: "Wedge Wire V-Profile & Cross-Flow Slot Geometry",
    zh: "楔形丝 V 型型材截面与横流防堵缝隙结构原理",
    es: "Geometría de perfil en V y ranura de flujo cruzado en alambre en cuña",
    de: "V-Drahtprofil und Querstrom-Spaltgeometrie des Bogensiebs",
    fr: "Géométrie du profil en V et de fente à flux transversal",
    pt: "Geometria de perfil em V e fenda de fluxo cruzado em arame cunha"
  });
  const diagramLead = pick(lang, {
    en: "Cross-sectional schematic showing outward-narrowing V-wire profiles, continuous slot aperture, and inward-widening relief for static non-clogging dewatering.",
    zh: "截面原理图展示外窄内宽 V 型型材丝、连续缝隙开孔以及向下游放大的自释放通道，实现静态防堵固液脱水。",
    es: "Esquema en corte que muestra el perfil en V con ranura continua y alivio interior para una deshidratación continua sin obstrucciones.",
    de: "Querschnittsschema mit sich nach innen erweiterndem V-Profil und kontinuierlicher Spaltöffnung für verstopfungsfreie statische Entwässerung.",
    fr: "Schéma en coupe illustrant le profil en V à fente continue et dégagement intérieur anti-colmatage pour égouttage statique.",
    pt: "Esquema em corte demonstrando o perfil em V com fenda contínua e alívio interno para desaguamento estático antientupimento."
  });
  const cardTitle = pick(lang, {
    en: "V-Wire Profile on Support Rod Cross-Section",
    zh: "梯形截面丝与支撑横梁熔焊截面",
    es: "Corte transversal de alambre en V sobre varilla de soporte",
    de: "Querschnitt von V-Draht und Tragstab",
    fr: "Coupe transversale du fil en V sur tige de support",
    pt: "Corte transversal de arame em V sobre barra de suporte"
  });
  const cardDesc = pick(lang, {
    en: "Slurry flows across perpendicular surface wires; leading profile edges slice thin liquid layers through the inward-expanding slot while solids glide over.",
    zh: "悬浮物料横向冲刷垂直排列的表面型线，迎流刃口将水力薄层剪切剥离排入内宽缝隙，固体物料顺畅沿筛面滑出。",
    es: "La suspensión fluye sobre alambres perpendiculares; las aristas cortan capas finas de líquido hacia las ranuras mientras los sólidos se deslizan.",
    de: "Suspension strömt quer über die Profildrähte; Drahtkanten schälen dünne Flüssigkeitsschichten ab, während Feststoffe abgleiten.",
    fr: "La suspension s'écoule transversalement ; les arêtes des fils cisaillent de minces films liquides évacués par les fentes.",
    pt: "A polpa escoa transversalmente sobre os arames; as arestas de ataque separam lâminas líquidas pelas fendas enquanto os sólidos deslizam."
  });
  const diagramSlot = <DiagramSection id="sieve-bend-diagram" title={diagramTitle} lead={diagramLead} tone="muted">
      <div className="max-w-2xl mx-auto">
        <DiagramCard index="01" badge="Profile" title={cardTitle} description={cardDesc}>
          <WedgeWireProfileDiagram variant="profile" />
        </DiagramCard>
      </div>
    </DiagramSection>;
  return <SubPageLayout content={content} diagram={diagramSlot} />;
}